module.exports = __webpack_public_path__ + "static/media/Elizabeth.a411de63.jpg";